<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box no-display" >
      <v-toolbar flat dense class="toolbar no-display">
        <v-toolbar-title>Misc And Other Fees Payment Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row dense justify="center" class="no-display">
        <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
          <v-radio label="DateWise" value="datewise" color="#0f2027"
            @change="mics_other_fees_student_records = []"></v-radio>
          <v-radio label="Standard/Division Wise" value="standardwise" color="#0f2027"
            @change="mics_other_fees_student_records = []"></v-radio>
        </v-radio-group>
      </v-row>


      <v-row justify="center" dense v-if="radios == 'datewise'" class="no-display">
        <v-col cols="12" sm="2" md="2" lg="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
            item-text="ay" return-object label="Academic Year" outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9">
          <v-icon color="error">*</v-icon>
          From Date ::
          <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
          <small class="ml-2 text-muted">(Inclusive)</small>
          <span class="mx-5"></span>
          <v-icon color="error" class="ml-3">*</v-icon>
          To Date ::
          <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />
          <small class="ml-2 text-muted">(Exclusive)</small>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-switch color="#0F2027" v-model="sort_date_wise" label="Sort Date Wise"></v-switch>
        </v-col>
        <v-btn @click="getReport()" :disabled="
            current_academic_year == null || fromdate == null || todate == null
          " :loading="loader" class="button mt-7 pt-0">Proceed</v-btn>
      </v-row>
      <v-row justify="center" dense v-if="radios == 'standardwise'" class="no-display">
        <v-col cols="12" sm="2" md="2" lg="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
            item-text="ay" return-object label="Academic Year" outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="standard" :items="standard_list" item-text="standard"
            item-value="id" label="Standard" outlined @change="get_divisions_stream()"></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2" v-if="division_list!=''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="division" :items="division_list" item-text="divname"
            item-value="id" label="Division" outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2" v-if="division_list!=''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="misc_fees_master" :items="misc_fees_master_list"
            item-text="name" item-value="id" label="Misc" outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2" v-if="division_list!=''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="learner_status" :items="learner_status_list" item-text="name"
            item-value="id" label="Learner Status" outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2" v-if="division_list!=''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="status" :items="status_list" item-text="name" item-value="id"
            label="Status" outlined></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="2" md="2" lg="2" v-if="division_list!='' &&status">
          <v-btn @click="getReport2()" :loading="loader" class="button mt-7 pt-0">Proceed</v-btn>
        </v-col>
      </v-row>

    </v-card>
    <v-card class="box" v-if="mics_other_fees_student_records != ''">
      <div id="my-table-id">
        <v-data-table v-if="mics_other_fees_student_records.length > 0" dense :headers="headers" :items="bookList1"
          :search="search" class="elevation-1 mytable" @current-items="getFiltered">
          <template v-slot:top class="pb-5">
            <v-row justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-col cols="12" sm="12" md="12">
                      <v-row>
                        <!-- <download-excel
                        class="mr-2 pb-3 pt-2"
                        :data="bookList1"
                        :fields="table_fields"
                        worksheet="Student_List"
                        name="Student_List.xls"
                      >
                        <v-btn color="success" outlined rounded>
                          <v-icon dark>mdi-file-excel</v-icon> Export
                        </v-btn>
                      </download-excel> -->
                        <v-btn rounded color="success" outlined class="no-display"
                          @click="fnExcelReport('my-table-id', 'MiscAndOtherFeesPaymentReport')"
                          :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>

                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printReport()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>

                        <span v-for="header in headers" :key="header.text" class="no-display">
                          <span v-if="filters.hasOwnProperty(header.value)">
                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                              color="#0F2027" :label="header.text" multiple clearable
                              :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                          </span>
                        </span>
                      </v-row>
                    </v-col>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    status_list: [], status: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    learner_status_list:[
    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
    ],learner_status:"",
    misc_fees_master_list:[],misc_fees_master:"",
    division_list:[],division:"",
    ay2:"",
    standard_list:[],standard:"",
    radios:null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    academic_year_list: null,
    current_academic_year: null,
    mics_other_fees_student_records: [],
    loader: false,
    filterArr: [],
    fromdate: null,
    todate: null,
    sort_date_wise: false,
    filters: {
      standard: [],
      division: [],
      prn_no: [],
      exam_name: [],
      payment_mode: [],
      misc_category: [],
    },
    table_fields: {
      "Sr. No": "srno",
      "PRN. Number": "prn_no",
      "Student Name": "stud_name",
      "Contact No.": "both_mobile_no",
      Standard: "standard",
      Division: "division",
      "Misx Name": "exam_name",
      "Misc Category Name": "misc_category",
      "Payment Mode": "payment_mode",
      Date: "paidon",
      "Amount to collected": "ammount_to_collected",
      "Amount Paid": "ammount_paid",
      Remaining: "remaining_amount",
    },
    headers: [
      { text: "Sr. No.", value: "srno", sortable: false },
      { text: "Student Name", value: "stud_name", sortable: false },
      { text: "Contact No", value: "both_mobile_no", sortable: false },
      { text: "PRN No.", value: "prn_no", sortable: false },
      { text: "Class", value: "standard", sortable: false },
      { text: "Div", value: "division", sortable: false },
      { text: "Misc Name", value: "exam_name", sortable: false },
      { text: "Misc Category Name", value: "misc_category", sortable: false },
      { text: "Payment Mode", value: "payment_mode", sortable: false },
      { text: "Payment Date", value: "paidon", sortable: false },
      {
        text: "Amount to collected",
        value: "ammount_to_collected",
        sortable: false,
      },
      { text: "Amount Paid", value: "ammount_paid", sortable: false },
      { text: "Remaining", value: "remaining_amount", sortable: false },
    ],
  }),
  computed: {
    bookList1() {
      return this.mics_other_fees_student_records.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    get_divisions_stream() {
            const formData = {
                ay: this.current_academic_year.id,
                standard: this.standard,
            };
              this.division_list=[]
            axios
                .post("/InstallmentStructureDetails/getDivisionOfferings", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.division_list = res.data.division_list;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.stream = "";
                });
        },
        fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Student Name</th>
      <th>Contact No</th>
      <th>PRN No.</th>
      <th>Class</th>
      <th>Div</th>
      <th>Misc Name</th>
      <th>Misc Category name</th>
      <th>Payment Mode</th>
      <th>Payment Date</th>
      <th>Amount to Collected</th>
    </tr>`;

  this.bookList1.forEach((s, index) => {
    tab_text += `
      <tr>
        <td>${index + 1}</td>
        <td>${s.stud_name}</td>
        <td>${s.both_mobile_no}</td>
        <td>${s.prn_no}</td>
        <td>${s.standard}</td>
        <td>${s.division}</td>
        <td>${s.exam_name}</td>
        <td>${s.misc_category}</td>
        <td>${s.payment_mode}</td>
        <td>${s.paidon}</td>
        <td>${s.ammount_to_collected}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},

     printReport() {
  this.$store.state.drawer = false;

  const that = this;

  window.onafterprint = function () {
    that.$store.state.drawer = true;
    window.onafterprint = null;
  };

  setTimeout(() => {
    window.print();
  }, 300);
},
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.mics_other_fees_student_records.map((d) => d[val]);
    },
    getReport2() {
      const formData = {
        ay: this.current_academic_year.id,
        division:this.division,
        misc_fees_master:this.misc_fees_master,
        status:this.status,
        standard:this.standard,
        learner_status:this.learner_status
      };
      this.loader = true;
      this.mics_other_fees_student_records=[]
      axios
        .post("/MiscAndOtherFees/getMiscAndOtherFeesPaymentReportSemester", formData)
        .then((res) => {
           if (res.data.flag == "YES") {
          this.mics_other_fees_student_records = res.data.stud_misc;
          this.loader = false;
           }
        })
        .catch((error) => {
          window.console.log(error);
          this.loader = false;
        })
        .finally(() => {
          //close loader
          this.loader = false;
        });
    },
    getReport() {
      if (this.current_academic_year == null) {
        alert("Please select AY!!!");
        return;
      }
      if (this.fromdate == null) {
        alert("Please select From Date!!!");
        return;
      }
      if (this.todate == null) {
        alert("Please select To Date!!!");
        return;
      }
      const formData = {
        ay: this.current_academic_year.id,
        fromdate: this.fromdate,
        todate: this.todate,
        sort_date_wise: this.sort_date_wise,
      };
      this.loader = true;
      axios
        .post("/MiscAndOtherFees/getMiscAndOtherFeesPaymentReport", formData)
        .then((res) => {
          this.mics_other_fees_student_records =
            res.data.mics_other_fees_student_records;
          this.loader = false;
        })
        .catch((error) => {
          window.console.log(error);
          this.loader = false;
        })
        .finally(() => {
          //close loader
          this.loader = false;
        });
    },
    get_ay_std() {
      //api-1
      axios
        .post("/InstallmentStructureDetails/getAllData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.ay_data;
            this.current_academic_year = res.data.cay;
            this.standard_list = res.data.user_wise_standard_list;
            this.status_list = res.data.status_list;
            this.misc_fees_master_list = res.data.misc_fees_master_list;

            if(this.standard_list.length > 0){
              this.standard_list = [{ id: null, standard: "All" }, ...(res.data.user_wise_standard_list || [])];
            }
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //close loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.get_ay_std();
  },
};
</script>
<style scoped>
input[type="date"] {
  width: 30%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.mytable thead th {
  background: #2980b9 !important ;
  background-color: #2980b9;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

@media print {

  body {
    height: 100%;
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Hide all elements having no-display */
  .no-display {
    display: none !important;
  }

  /* Hide v-data-table top section */
  .mytable >>> .v-data-table__top {
    display: none !important;
  }

  /* Hide Rows per page / pagination section */
  .mytable >>> .v-data-footer {
    display: none !important;
  }

  /* Remove card/shadow around table */
  .mytable {
    box-shadow: none !important;
  }

  /* Keep table width */
  .mytable >>> .v-data-table__wrapper {
    overflow: visible !important;
  }

  /* Keep table exactly like normal table */
  .mytable table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

}
</style>
